import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { UPDATE_REALMS_DATA, UPDATE_REALMS_DATA_ERROR, UPDATE_REALMS_DATA_LOADING } from '../actions/realmActions';
import { TAction } from '../actions/types/action';
import { TRealmPreviewState, TRealmsClientState } from '../libs/store';

export default function realmListingReducer(
  state: Partial<TRealmsClientState> = {},
  action: TAction<any>
): Partial<TRealmsClientState | TRealmPreviewState> {
  switch (action.type) {
    case UPDATE_REALMS_DATA: {
      return {
        ...state,
        ...action.payload,
        isLoading: false
      };
    }
    case UPDATE_REALMS_DATA_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case UPDATE_REALMS_DATA_ERROR: {
      return {
        ...state,
        error: action.payload,
        isError: true,
        isLoading: false
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return {};
    }
    default:
      return state;
  }
}
